module.exports = __webpack_public_path__ + "static/media/CircleImage.0eb6beb6.jpg";